import { useContent } from '../hooks/useContent';
import './Footer.css';

const Footer = () => {
    const { ui, CONTACTS } = useContent();
    const f = ui.footer;
    const socialIcons = [
        { title: 'Instagram', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg> },
        { title: 'Facebook', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> },
        { title: 'LinkedIn', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg> },
        { title: 'Telegram', icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> }
    ]
  return (
    <footer id="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <a href="#" className="nav-brand" style={{textDecoration:'none'}}>
                <img src="/logoru.png" alt={ui.brand.alt} className="footer-logo" />
            </a>
            <p>{f.about}</p>
          </div>

          <div className="footer-col">
            <h4>{f.nav}</h4>
            <ul>
              <li><a href="#news">{f.links.news}</a></li>
              <li><a href="#programs">{f.links.programs}</a></li>
              <li><a href="#faq">{f.links.faq}</a></li>
              <li><a href="#contacts">{f.links.contacts}</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{f.contacts}</h4>
            <ul>
              <li><a href="tel:+77172695060">{CONTACTS.phone1}</a></li>
              <li><a href="tel:+78000802828">{CONTACTS.phone2}</a></li>
              <li><a href="mailto:fincenter@fincenter.kz">{CONTACTS.email}</a></li>
              <li><a href="#" aria-label="Адрес">{CONTACTS.address}</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{f.materials}</h4>
            <ul>
              <li><a href="#faq">{f.links.presentations}</a></li>
              <li><a href="#state-funding">{f.links.funding}</a></li>
              <li><a href="#story">{f.links.history}</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">{f.copy}</span>
          <div className="footer-socials">
            {socialIcons.map(s => (
                <div className="social-btn" title={s.title} key={s.title}>
                   {s.icon}
                </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
